import { render, staticRenderFns } from "./ProcessAccident.vue?vue&type=template&id=5db05378&scoped=true"
import script from "./ProcessAccident.vue?vue&type=script&lang=js"
export * from "./ProcessAccident.vue?vue&type=script&lang=js"
import style0 from "./ProcessAccident.vue?vue&type=style&index=0&id=5db05378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db05378",
  null
  
)

export default component.exports